import { queryOptions } from '@tanstack/react-query'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import {  fetchRacePendingTicketsCount } from './api'

const enum LocalConstants {
  PollingTimeMs = 1_000 * 60 * 15, // 15mins
}

export const racingPendingTicketsPollingQuery = queryOptions({
  queryKey: queryKeys.pendingTicketsCountRacing,
  queryFn: fetchRacePendingTicketsCount,
  refetchOnWindowFocus: true,
  refetchOnMount: true,
  staleTime: LocalConstants.PollingTimeMs,
  refetchInterval: LocalConstants.PollingTimeMs,
})
